import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Avatar, ListItem, ListItemAvatar, ListItemText, Skeleton } from '@mui/material';
import { Remove, Error } from '@mui/icons-material';
import React from 'react';
import { useVerifyLotQuery } from '../features/api/rest/apiLotsSlice';
import ChildrenLotInformation from './ChildrenLotInformation';
function LotInformation({ ean, authority, code, isRoot = true }) {
  const { t } = useTranslation();

  const { lot, isFetching, isLoading, isError } = useVerifyLotQuery(
    { ean, aut: authority, lotCode: code },
    {
      selectFromResult: (result) => ({
        ...result,
        lot: result.data?.results[0] || {},
      }),
    }
  );

  if (isFetching || isLoading) return <Skeleton animation="wave" />;

  if (isError || Object.keys(lot).length === 0)
    return (
      <ListItem sx={{ p: 0 }} divider>
        <ListItemAvatar>
          <Avatar sx={{ bgcolor: 'white', color: 'black', width: 24, height: 24 }}>{<Remove />}</Avatar>
        </ListItemAvatar>
        <ListItemAvatar>
          <Avatar sx={{ bgcolor: 'white', color: 'gray' }}>{<Error data-testid="error" />}</Avatar>
        </ListItemAvatar>
        <ListItemText primaryTypographyProps={{ display: 'inline' }} primary={t('products.lots.errorRetrievingLot')} />
      </ListItem>
    );

  return <ChildrenLotInformation orgId={lot.organization_id} orgName={lot.organization_name} authority={lot.authority} code={lot.code} info={lot.info} validFrom={lot.valid_from} validTo={lot.valid_to} children={lot.children} isRoot={isRoot} />;
}

LotInformation.propTypes = {
  ean: PropTypes.string.isRequired,
  authority: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
};

export default LotInformation;
